import React from 'react';

const widths = ['100%', '75%', '85%', '60%', '90%', '70%'];

const LoadingSkeleton = ({ rows = 3, hasTitle = true, cardStyle = true }) => {
  const content = (
    <>
      {hasTitle && (
        <div className="skeleton" style={{ height: 18, width: '45%', borderRadius: 4, marginBottom: 16 }} />
      )}
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="skeleton"
          style={{
            height: 13,
            width: widths[i % widths.length],
            borderRadius: 4,
            marginBottom: i < rows - 1 ? 10 : 0,
          }}
        />
      ))}
    </>
  );

  if (!cardStyle) return <div>{content}</div>;

  return (
    <div className="card">
      <div className="card-body">{content}</div>
    </div>
  );
};

export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <div className="table-wrap">
    <div className="table-scroll">
      <table className="crm-table">
        <thead>
          <tr>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i}>
                <div className="skeleton" style={{ height: 11, width: '70%', borderRadius: 3 }} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, ri) => (
            <tr key={ri}>
              {Array.from({ length: cols }).map((_, ci) => (
                <td key={ci}>
                  <div
                    className="skeleton"
                    style={{ height: 13, width: widths[(ri + ci) % widths.length], borderRadius: 4 }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default LoadingSkeleton;
